import {
  AreaChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Area,
  Legend,
  LegendProps,
} from 'recharts';

type AreaChartData = Array<{
  name: string;
  sales: number;
  earnings: number;
}>;
export const salesTrendDummyData: AreaChartData = [
  {
    name: 'product A',
    sales: 0,
    earnings: 0,
  },
  {
    name: 'product B',
    sales: 0,
    earnings: 0,
  },
  {
    name: 'product C',
    sales: 0,
    earnings: 0,
  },
  {
    name: 'product D',
    sales: 0,
    earnings: 0,
  },
  {
    name: 'product E',
    sales: 0,
    earnings: 0,
  },
  {
    name: 'product F',
    sales: 0,
    earnings: 0,
  },
  {
    name: 'product G',
    sales: 0,
    earnings: 0,
  },
];

const CustomLegend = (props: LegendProps) => {
  const { payload } = props;

  return (
    <ul style={{ listStyle: 'none', display: 'flex', gap: '1.5rem' }}>
      {payload!.map((entry, index) => (
        <li
          key={`item-${index}`}
          className="text-text-dark-low capitalize flex items-center gap-1.5"
        >
          <span
            style={{ backgroundColor: entry.color }}
            className="block w-3 h-3 rounded-sm"
          ></span>
          {entry.value}
        </li>
      ))}
    </ul>
  );
};

export default function SalesTrendChart({ data }: { data: AreaChartData }) {
  return (
    <div className="h-full w-full bg-white rounded-md border border-border flex flex-col gap-4">
      <div className="p-4 border-b border-border">
        <h6 className="font-bold">Sales Trend</h6>
      </div>
      <div className="w-full min-w-full flex-1 ">
        <ResponsiveContainer width="100%" minWidth="100%" height="100%">
          <AreaChart
            data={data}
            margin={{ top: 40, right: 20, left: 0, bottom: 0 }}
          >
            <defs>
              <linearGradient id="colorSales" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#D9DFE980" stopOpacity={0.8} />
                <stop offset="95%" stopColor="#FFFFFF00" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="colorEarning" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#3694EB4D" stopOpacity={0.5} />
                <stop offset="85%" stopColor="#FFFFFF00" stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis
              axisLine={false}
              dataKey="name"
              tick={{ fontSize: 10, strokeWidth: 1 }}
            />
            <YAxis axisLine={false} tick={{ fontSize: 10, strokeWidth: 1 }} />
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <Tooltip />
            <Area
              dataKey="sales"
              stroke="#D9DFE9"
              fillOpacity={1}
              fill="url(#colorSales)"
            />
            <Area
              dataKey="earnings"
              stroke="#0A77FF"
              fillOpacity={1}
              fill="url(#colorEarning)"
            />
            <Legend
              iconType="square"
              content={<CustomLegend />}
              wrapperStyle={{ top: 0, right: 25, width: 'fit-content' }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
